export default {
  appname: 'platzimusic',
  apiKey: '41b6df4ed1333a48bf4edff05bf8fde2',
  secret: 'a93b943069e911d3538582aa206170bc',
  registeredTo: 'fcor14'
}

// Application name	platzimusic
// API key	41b6df4ed1333a48bf4edff05bf8fde2
// Shared secret	a93b943069e911d3538582aa206170bc
// Registered to	fcor14



// WEBPACK FOOTER //
// ./src/api/config.js